import React, { useState } from "react";
import { isTrivvyUrl, isTrivvyProduct } from "../../utils/constants";
import * as actionCreators from "../../modules/actions/index";
import * as url from "../../utils/url";
// import {NavBarLogo, Logo} from '../Logo/Logo';
import Logo from "../Logo/Logo";
import moment from "moment";
import "./NavBar.css";
import axios from "../../axios";
import { Link } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
  Progress,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  ModalFooter,
  Label,
} from "reactstrap";
import { LuMail, LuSend, LuX } from "react-icons/lu";
import { toastContainer } from "../../utils/toast";
import "./contact-us-bwai.css";

export default function ContactUsModal({ user, open, onClose }) {
  const [message, setMessage] = useState("");

  const sendMessage = () => {
    axios
      .post(url.sendUserContactUsMessage, {
        message: message,
        toEmail: isTrivvyUrl(user.organizationId)
          ? "trivvy@ouroffice.io"
          : "team@ouroffice.io",
        // toEmail:"abhishek.thorat@mindbowser.com",
        organizationName:user.organizationId.name
      })
      .then(({ data }) => {
        toastContainer("Message sent successfully", "success");
      })
      .catch((err) => {
        toastContainer("Error while sending message", "error");
      });
  };
  return (
    <Modal isOpen={open} className="bwai-contact-modal">
      <ModalHeader
        className="bwai_contact_header"
        close={
          <button
            type="button"
            className="bwai-contact-close"
            aria-label="Close"
            onClick={onClose}
          >
            <LuX />
          </button>
        }
      >
        <span className="bwai-contact-title-row">
          <span className="bwai-contact-icon-tile">
            <LuMail />
          </span>
          <span className="bwai-contact-title">Contact us</span>
        </span>
      </ModalHeader>
      <ModalBody>
        <Label className="bwai-contact-intro">
          Send us a message so our team can get in touch with you.
        </Label>
        <Input
          className="bwai-contact-textarea"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          type="textarea"
          rows={4}
          placeholder="Type your message here..."
        />
      </ModalBody>
      <ModalFooter className="bwai-contact-footer">
        <Button className="bwai-contact-cancel" onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={sendMessage}
          color="primary"
          className="bwai-contact-send"
        >
          <LuSend />
          Send message
        </Button>
      </ModalFooter>
    </Modal>
  );
}
